module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0078.jpg?v=2b6e4eb0";